module.exports = "../images/homepage/landscape.jpg";